import { NgModule } from "@angular/core";
import { RutDirective } from './rut-validador.directive'
import { RutPipe } from './rut-validador.pipe'

@NgModule({
  declarations: [RutDirective,RutPipe],
  exports:[RutDirective,RutPipe]
})
export class RutValidadorModule{}
